export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8895.d2795f30.jpg";